export type CreditNoteTaxScenario = {
  tax1Id: string;
  itemTaxKey: string;
  itemTaxPercent: number;
  itemTaxType: string;
  vatTreatment: string;
};

// Maps a farm's banking-detail tax rate to the fixed set of credit-note export
// columns that travel together for that tax scenario. New tax scenarios
// require a new entry here (and a matching translation key in points.json).
export const CREDIT_NOTE_TAX_SCENARIOS: Record<number, CreditNoteTaxScenario> = {
  19: {
    tax1Id: "774840000000129068",
    itemTaxKey: "zzgl. Umsatzsteuer",
    itemTaxPercent: 19,
    itemTaxType: "ItemAmount",
    vatTreatment: "home_country",
  },
  7.8: {
    tax1Id: "774840000000056507",
    itemTaxKey: "Landwirtschaftliche Pauschalsteuer",
    itemTaxPercent: 7.8,
    itemTaxType: "ItemAmount",
    vatTreatment: "home_country",
  },
  0: {
    tax1Id: "774840000000056161",
    itemTaxKey: "VAT Rate",
    itemTaxPercent: 0,
    itemTaxType: "ItemAmount",
    vatTreatment: "eu_vat_registered",
  },
};

export const CREDIT_NOTE_ACCOUNT = "Erlöse";
export const CREDIT_NOTE_ACCOUNT_CODE = "8200";

// Used for the "credits only" payout flow, where footprinting and incentives are paid out externally
// and must be omitted from the credit-note export entirely.
export const CREDIT_ONLY_ITEM_TYPES = [{ netField: "creditPaymentNet", itemNameKey: "creditNoteExport.itemName.creditsOffsetting" }] as const;

// Which payment types produce a credit-note row/number.
export const CREDIT_NOTE_ITEM_TYPES = [
  ...CREDIT_ONLY_ITEM_TYPES,
  { netField: "incentivePaymentNet", itemNameKey: "creditNoteExport.itemName.incentives" },
  { netField: "footprintingPaymentNet", itemNameKey: "creditNoteExport.itemName.footprinting" },
] as const;

export type CreditNoteItemType = (typeof CREDIT_NOTE_ITEM_TYPES)[number];
